<ng-container *ngrxLet="onboardingSteps$ as steps">
  <atx-modal-header
    class="pb-0"
    [showCloseBtn]="['fas', 'xmark']"
    (dismiss)="close()"
  >
    <div
      class="d-flex justify-content-center align-items-center py-1 position-relative"
    >
      <atx-image
        class="logo logo-filter"
        data-e2e="onboarding-site-logo"
        [imageUrl]="currentSiteLogo$ | async"
        [maxWidth]="150"
        failedLoadIconSize="1x"
        [hidden]="hideTenantLogo$ | async"
      ></atx-image>
      <img
        class="ml-3 owner-logo logo-filter"
        alt="logo"
        src="assets/logo-neocles.svg"
        height="16px"
        [hidden]="hideNeoclesLogo$ | async"
      />
    </div>
  </atx-modal-header>
  <atx-modal-body>
    <atx-stepper>
      @for ( step of steps; track step; let idx = $index; let first = $first;
      let last = $last) {
      <atx-step>
        <epc-onboarding-item
          [item]="step"
          [isActive]="stepper?.selectedIndex === idx"
        >
        </epc-onboarding-item>
      </atx-step>
      }
    </atx-stepper>
  </atx-modal-body>

  <atx-modal-footer class="justify-content-between border-0">
    @if (!stepper?.isLastStep) {
    <button
      (click)="stepper?.previous()"
      [class.invisible]="stepper?.isFirstStep"
      class="btn btn-light btn-lg"
      i18n="Onboarding|Previous button text@@onboardingPreviousButtonText"
      data-e2e="onboarding-previous-btn"
    >
      Previous
    </button>
    } @if (stepper?.isLastStep) {
    <button
      (click)="stepper.reset()"
      type="button"
      class="btn btn-link text-primary btn-lg d-flex align-items-center justify-content-center"
      data-e2e="onboarding-reset-btn"
    >
      <fa-icon
        size="xs"
        [icon]="['fas', 'rotate-left']"
        flip="horizontal"
      ></fa-icon>
      <span
        class="ml-2"
        i18n="
          Onboarding|Restart onboarding button text@@onboardingRestartButtonText"
        >Restart onboarding</span
      >
    </button>
    }
    <atx-stepper-indicators
      [steps]="stepper?.steps"
      [currentIndex]="stepper?.selectedIndex"
      (indicatorChanged)="stepper?.selectedStepByIndex($event)"
    ></atx-stepper-indicators>
    @if (stepper?.isLastStep) {
    <button
      data-e2e="onboarding-last-btn"
      (click)="close()"
      class="btn btn-primary btn-lg d-flex align-items-center justify-content-center"
    >
      <ng-container *ngTemplateOutlet="rightBtnTpl"></ng-container>
    </button>
    } @else {
    <button
      data-e2e="onboarding-dynamic-btn"
      (click)="stepper?.next()"
      class="btn btn-primary btn-lg d-flex align-items-center justify-content-center"
    >
      <ng-container *ngTemplateOutlet="rightBtnTpl"></ng-container>
    </button>
    }
  </atx-modal-footer>

  <ng-template #rightBtnTpl>
    <span class="mr-2">{{
      steps[stepper?.selectedIndex]?.nextButtonTranslationKey
    }}</span>
    <fa-icon size="xs" [icon]="['fas', 'arrow-right']"></fa-icon>
  </ng-template>
</ng-container>
